export default "__VITE_ASSET__CqYRPwYw__"